import myAxios from './request'
// 查询所有的期刊
export function list() {
  return myAxios({
    url: '/journal',
    method: 'get',
  })
}
